export default __webpack_public_path__ + "static/media/home-6.65636087.png";